import React from 'react';
import Header from '../../../components/header';
import Intro from './intro';
import Board from './board-member';
import Management from './management';

import { useLanguage } from '../../../helpers/language-context';

const OurTeam = () => {
  const { translations } = useLanguage();
  return (
    <div className="ourteam-container">
      <Header 
        title={translations.about.ourTeam} 
        flip={true} 
        bgImg="/assets/images/header-bg/bg_ourteam_new.jpg" 
        bgClassName="bg-[size:270%] bg-[position:43%_center] md:bg-cover md:bg-center"
      />
      <Intro />
      <Board />
      <div className="bg-white w-full">
        <div className="h-screen">
          <img src="/assets/images/section-img/section_board_new.jpg" alt="Our Team" className="object-cover h-screen w-full" />
        </div>
      </div>
      <Management />
    </div>
  );
};

export default OurTeam;
